export const WIZARD_ARTICLES_QUERY_KEY = 'wizardArticles'
